import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { LinkDownload, LinkDownload4Chart } from "../analytics/analytics-types";
import { useTranslation } from "react-i18next";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import NoDataToBeShown from "../reusable/NoDataToBeShown";
import ErrorComponent from "../reusable/ErrorComponent";
import BarChartIcon from "@mui/icons-material/BarChart";
import { grey } from "@mui/material/colors";

/* Component to show links usage */
export function Skeleton4Chart() {
  return <Skeleton variant="rectangular" width={"100%"} height={"40vh"} />;
}

export default function LinkChart(props: {
  downloads: LinkDownload[];
  loading: boolean;
  isDashboard: boolean;
  isError: any;
}) {
  const { t } = useTranslation();
  const DownloadsForPlot: LinkDownload4Chart[] = [];

  props.downloads.map((element) => {
    const downloadObject: LinkDownload4Chart = { x: "", y: 0 };
    downloadObject.x = props.isDashboard
      ? element.appName
      : element.versionNumber;
    downloadObject.y = element.downloads;
    downloadObject.goals = [
      {
        name: "Max downloads",
        value: element.maxdownloads,
        strokeHeight: 5,
        strokeColor: "#FF4949",
      },
    ];

    DownloadsForPlot.push(downloadObject);

    return DownloadsForPlot;
  });

  const chartData: ApexOptions = {
    chart: {
      width: "100%",
      type: "bar",
      id: "apexchart-example",
      toolbar: {
        show: true,
        offsetX: 0,
        offsetY: 0,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: false,
          customIcons: [],
        },
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
      },
    },
    xaxis: {
      title: {
        text: props.isDashboard ? t("Applications") : t("Versions"),
      },

      categories: props.downloads.map((item) => item.uuid),
    },
    yaxis: {
      title: {
        text: "Downloads",
      },
      floating: false,
      axisBorder: {
        show: false,
      },
      min: 0,
      /*   labels: {
        formatter: function (val) {
          return val.toFixed(0);
        },
      }, */
    },

    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "horizontal",
        shadeIntensity: 0.5,
        gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 100],
        // colorStops: []
      },
    },
    legend: {
      show: true,
      position: "top",
      width: 400,
      horizontalAlign: "right",
      // position: 'top',
    },
    title: {
      text: t("Total downloads per link"),
      floating: true,
      margin: 2,
      align: "center",
      offsetY: 2,
      offsetX: 2,
      style: {
        color: "#444",
      },
    },
    series: [
      {
        name: t("Download amount"),
        type: "bar",
        data: DownloadsForPlot,
      },
    ],
  };

  return (
    <Card
      sx={{
        boxShadow: 5,
        borderRadius: 1.5,
        height: 400,
        justifyContent: "center",
        alignItems: "center",
      }}
      style={{ height: "100%" }}
    >
      <CardHeader title={t("Downloads per link") + " " + t("(Last day)")} />
      <CardContent>
        {props.loading ? (
          <Skeleton4Chart />
        ) : props.downloads.length > 0 ? (
          <ReactApexChart options={chartData} series={chartData.series} />
        ) : !props.isError && props.downloads.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              height: "40vh",
              alignItems: "center",
            }}
          >
            <Stack justifyContent="center" alignItems="center">
              <BarChartIcon sx={{ fontSize: 60, color: grey[500] }} />
              <Stack>
                <NoDataToBeShown />
                <Typography textAlign="center">
                  {t("Share you apps to see your downloads trend.")}
                </Typography>
              </Stack>
            </Stack>
          </Box>
        ) : (
          props.isError && <ErrorComponent />
        )}
      </CardContent>
    </Card>
  );
}
